import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_FUNCTION_URL, BASE_URL } from "../App";
import { useLocalStorage } from "./LocalStorageHook";
import { PlanningItem } from "../pages/RoutePlanning/index";
import download  from 'downloadjs'

export async function getPlanningList(salesOrg: string, plant: string, route: string, planningDate: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      plant,
      route,
      planningDate,
    },
    url: `${BASE_URL}/api/planning/list`,
    timeout:600000
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => {
      v.data.planning.map((aPlan : any) => {
        function convertTZWithMidnightTime(date: string | Date) {
          const inputDate = typeof date === "string" ? new Date(date) : date;
          const convertedDate = new Date(inputDate.toLocaleString("en-US"));
          convertedDate.setHours(0, 0, 0, 0); // Set time to midnight
          if(0 < (new Date().getTimezoneOffset()))
          {    
              convertedDate.setDate(convertedDate.getDate() + 1)
          }
          return convertedDate;
      }
      aPlan.nextDeliveryNewPlan = aPlan.nextDeliveryPlan ? convertTZWithMidnightTime(aPlan.nextDeliveryPlan): ''
      aPlan.sheduledNewDate = aPlan.sheduledDate ? convertTZWithMidnightTime(aPlan.sheduledDate) : '' 
      aPlan.nextNewDeliveryAct = aPlan.nextDeliveryAct ? convertTZWithMidnightTime(aPlan.nextDeliveryAct): ''
      })
      return v.data
    })
    .catch((err) => console.error(err));
}

export async function getPlanningDynamicList(salesOrg: string, plant: string, planningDate: string,route:string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      plant,
      planningDate,
      route
    },
    url: `${BASE_URL}/api/planning/dynamiclist`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
export async function getSettlementList(salesOrg: string, customerNum: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
    },
    url: `${BASE_URL}/api/planning/settlementDataList`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getMaterialsList(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/planning/allmatlist`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getCustomersList(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/planning/allcustomerslist`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getPlanningSettlement(salesOrg: string, customerNum: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
    },
    url: `${BASE_URL}/api/planning/sm`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getConfirmedRoutes(salesOrg: string, customerNum: string,planningDateStr:string,delivering_plant:any) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      // customerNum,
      planningDateStr,
      delivering_plant
    },
    url: `${BASE_URL}/api/planning/confirmed/routes`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getCustomerNums(salesOrg: string, searchID?: string, searchType?: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      searchID,
      searchType,
    },
    url: `${BASE_URL}/api/planning/sm_shipmentNum`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function updateClosingInventory(
  salesOrg: string,
  customerNum: string,
  shipmentNum: string,
  txSettlementItems?: any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      shipmentNum,
    },
    data: {
      txSettlementItems,
    },
    url: `${BASE_URL}/api/planning/updateClosingInventory`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function updateLastKnownInventory(
  salesOrg: string,
  customerNum: string,
  shipmentNum: string,
  orderNum:string,
  txVisitPlanningItems?:any,
  reconciliationNotes?:any,
  lastInventoryUpdateDate?:any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg, 
      customerNum: customerNum,
      shipmentNum: shipmentNum,
      orderNum:orderNum,
      lastInventoryUpdateDate:lastInventoryUpdateDate
    },
    data: {
      txVisitPlanningItems,
      reconciliationNotes,
    },
    url: `${BASE_URL}/api/planning/updateLastKnownInventory`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function setPlanningStatus(
  salesOrg: string,
  customerNums: any[],
  status: string,
  date: Date,
  data?: any,
  uuid?:any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      customers: customerNums,
      status,
      data,
      date,
      uuid,
    },
    url: `${BASE_URL}/api/planning/status`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function resetPlanningStatus(route:string,salesOrg: string, customerNums: string[], status: string, date: Date,uuid:any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      date,
      uuid
    },
    data: {
      customers: customerNums,
      status,
      date,
      route
    },
    url: `${BASE_URL}/api/planning/resetstatus`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function resetRoutePlan(
  salesOrg: string,deliveringPlant:string, route:string, planningDate: Date, uuid?:any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
     
    },
    data: {deliveringPlant:deliveringPlant,route:route, planningDate:planningDate,uuid},
    url: `${BASE_URL}/api/planning/resetrouteplan`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function setPlanningActivity(
  salesOrg: string,
  customerNum: string,
  equipmentNum: string,
  activity: any,
  planningDate:string,
  plant:string,
  route:string,
  uuid:any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      equipmentNum,
      planningDate,
      plant,
      route
    },
    data:{activity,uuid},
    url: `${BASE_URL}/api/planning/activity`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function setPlanningRoute(
  salesOrg: string,
  customerNum: string,
  equipmentNum: string,
  route: string,
  planningDateStr?: string,
  data?: any[],
  multiple?: boolean,
  uuid?:string
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      equipmentNum,
      multiple, 
      planningDateStr
    },
    data: {
      data,
      route,
      uuid
    
    },
    url: `${BASE_URL}/api/planning/route`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function setPlanningFTC(
  salesOrg: string,
  customerNum: string,
  equipmentNum: string,
  ftc: boolean,
  pi: PlanningItem,
  planningDateStr: string,
  plant: any,
  route: string,
  uuid: string,
  
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      equipmentNum,
    },
    data: {
      ftc,
      pi,
      planningDateStr,
      plant,
      route,
      uuid,
      
    },
    url: `${BASE_URL}/api/planning/ftc`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function releasePlanningMultiple(
  salesOrg: string,
  planningDatas: any,
  planMode: string,
  uuid?:any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      planMode: planMode,
    },
    data: {...planningDatas,uuid},
    url: `${BASE_URL}/api/planning/releasemultiple-new`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

// export async function releasePlanning(
//   salesOrg: string,
//   planningData: any,
//   planMode: string
// ) {
//   const config: AxiosRequestConfig = {
//     method: "POST",
//     params: {
//       clientId: "100",
//       salesOrg,
//       planMode,
//     },
//     data: planningData,
//     url: `${BASE_URL}/api/planning/release`,
//   };

//   return await AXIOS_INSTANCE(config)
//     .then((v) => v.data)
//     .catch((err) => console.error(err));
// }

export async function releasePlanning(
  salesOrg: string,
  planningData: any,
  planMode: string,
  uuid: string,
  
) {
  let obj={"plant":planningData?.plant,
  "route":planningData?.route,
  "loadDate":planningData?.loadDate,
  'customerList':planningData.customerList,
  'uuid':uuid
}
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      planMode,
    },
    data: obj,
    url: `${BASE_URL}/api/planning/release-new`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function saveReleaseDraft(
  salesOrg: string,
  data:any,
  planMode?: string
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      planMode: planMode,
    },
    data: data,
    url: `${BASE_URL}/api/planning/savereleasedraft`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function clearReleaseDraft(
  salesOrg: string,
  data:any,
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    data: data,
    url: `${BASE_URL}/api/planning/clearreleasedraft`,
  };

return await AXIOS_INSTANCE(config)
  .then((v) => v.data)
  .catch((err) => console.error(err));
}

export async function getReleaseDraft(
  salesOrg: string,
  salesOffice: string,
  route: string,
  planningDate?: string
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      salesOffice: salesOffice,
      planningDate: planningDate,
      route:route
    },
    url: `${BASE_URL}/api/planning/getreleasedraft`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getReleaseDrafts(
  salesOrg: string,
  salesOffice: string,
  routes: any,
  planningDate?: string
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      salesOffice: salesOffice,
      planningDate: planningDate,
      routes:routes
    },
    url: `${BASE_URL}/api/planning/getreleasedrafts`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function calcNewAverages(
  salesOrg: string,
  customerNum: string,
  equipmentNum: string,
  invoiceCount:number,
  appldWght:number
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      customer_num: customerNum,
      equipment_num: equipmentNum,
      invoice_count:invoiceCount,
      appld_wght:appldWght
    },
    url: `${BASE_URL}/api/planning/calcnewaverages`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getPlanningOverview(
  salesOrg: string,
  deliveryPlant: string,
  startDate: Date,
  planMode:string
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      deliveryPlant,
      startDate,
      planMode
    },
    url: `${BASE_URL}/api/planning/overview`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getSalesOfficesAndRoutes(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/planning/sor`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
export async function addMaterialAdjustments(salesOrg: string, data: any,createdDate:any,uuid:any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data:{...data,'createdDate':createdDate,'uuid':uuid},
    url: `${BASE_URL}/api/planning/addmaterialadjustments`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function removeMaterialAdjustments(salesOrg: string, data: any,createdDate:any,uuid:any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data:{...data,'createdDate':createdDate,'uuid':uuid},
    url: `${BASE_URL}/api/planning/removematerialadjustments`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getMaterialAdjustments(
  salesOrg: string,
  deliveryPlant: string,
  route: string,
  planningDate?: string
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      deliveryPlant,
      planningDate,
      route,
    },
    url: `${BASE_URL}/api/planning/getmaterialadjustments`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getAllMaterialAdjustments(
  salesOrg: string,
  deliveryPlant: string,
  route: string,
  planningDate: string
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      deliveryPlant,
      planningDate,
      route,
    },
    url: `${BASE_URL}/api/planning/getallmaterialadjustments`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}



export async function pdfDeleteByRoute(
  salesOrg: string,
  route:string,
  date: string,
  plant:string,

) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      date: date,
      route:route,
      plant:plant
    },
    data: {
      "route":route
    },
    url: `${BASE_URL}/api/planning/pdfDeleteByRoute`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}



export async function replanUpdate(
  salesOrg: string,
  route:string,
  date: string,
  plant:string,
  uuid:any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      date: date,
      route:route,
      plant:plant
    },
    data: {
      
      "date": date,
      "route":route,
      "uuid":uuid
    },
    url: `${BASE_URL}/api/planning/replanUpdate`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function getShduledRoute(
  salesOrg: string,
  route: string,
  customer_num:string,
  salesOffice: string

) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
       clientId: "100",
       salesOrg: salesOrg,
       route:route,
       customer_num:customer_num,
       salesOffice:salesOffice
    },
    url: `${BASE_URL}/api/planning/getMultipleroute`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}



export async function updateDate(
  salesOrg: string,
  customerNums: string[],
  date: Date,
  activeDate?:any,
  route?:string,
  data?:any,
  uuid?:any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    data: {
      "customers": customerNums,
      "date": date,
      "activeDate": activeDate,
      "route":route,
      data:data,
      uuid:uuid
    },
    url: `${BASE_URL}/api/planning/updateDate`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
export async function pdfGenerate(
  salesOrg: string,
  route:string[],
  date: string,
  plant: string,
) {

  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      date: date,
      plant,
    },
    data: {
      "route":route
    },
    url: `${BASE_URL}/api/planning/pdfGenerate`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));



}



export async function HistoryPdfRoute(
  salesOrg: string,
  date: string,
  plant: string,
  routes:string[]
) {

    const config: AxiosRequestConfig = {
      method: "POST",
      params: {
        clientId: "100",
        salesOrg: salesOrg,
        date: date,
        plant,

      },
      data: {
        routes
      },
      url: `${BASE_URL}/api/planning/pdfGeneratesHistoryByRoute`,
    };
  
    return await AXIOS_INSTANCE(config)
      .then((v) => {
        let pdfName=`${salesOrg}_${plant}_RouteCard.pdf`
        download(v.data, pdfName, "application/pdf");
        return v.data;
      
      })
      .catch((err) => console.error(err));



}




export async function HistoryPdf(
  salesOrg: string,
  date: string,
  plant: string,
  routes:string,
  customernumber:string[]
) {

    const config: AxiosRequestConfig = {
      method: "POST",
      params: {
        clientId: "100",
        salesOrg: salesOrg,
        date: date,
        plant,

      },
      data: {
        customernumber:customernumber,
        route:routes
      },
      url: `${BASE_URL}/api/planning/pdfGeneratesHistoryByCustomer`,
    };
  
    return await AXIOS_INSTANCE(config)
      .then((v) => {
        let pdfName=`${salesOrg}_${plant}_RouteCard.pdf`
        download(v.data, pdfName, "application/pdf");
        return v.data;
      
      })
      .catch((err) => console.error(err));



}




export async function customerPDFGenerate(
  planingData:any,
  salesOrg: string,
  route:string[],
  date: string,
  plant: string,
  customers:string,
  grid:string,

) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      date: date,
      plant:plant,
      
    },
    data: {
      "route":route,
      "customers": customers,
      "board" : grid,
      "planingData":planingData
    },
    url: `${BASE_URL}/api/planning/pdfGeneratesCustomer`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}




export async function setbulkSchedule(
  route: string,
  salesOrg: string,
  status: string,
  date: Date,
  data?: any,
  uuid?:any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      route:route,
      status,
      date,
      data,
      uuid
    },
    url: `${BASE_URL}/api/planning/bulkShedule`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function setbulkUnSchedule(
  selectedDeliveryPlant:string,
  route:string,
  salesOrg: string,
  status: string,
  date: Date,
  data?: any,
  uuid?:any

 
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      route:route,
      status,
      date,
      data,
      selectedDeliveryPlant,
      uuid
    },
    url: `${BASE_URL}/api/planning/bulkUnShedule`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function loadReportGenerate(
  salesOrg: string,
  route:string[],
  date: string,
  plant: string,
  planMode: string
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      date: date,
      plant,
      planMode
    },
    data: {
      "route":route
    },
    url: `${BASE_URL}/api/planning/loadReportGenerate`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}




export async function getusersheduledList(
  salesOrg: string,
  route:string[],
  visit_dt_plan:Date,
  deliveringplant:string
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
     

    },
    data: {
      "route_act": route,
      "visit_dt_plan":visit_dt_plan,
      "deliveringplant":deliveringplant
    },
    url: `${BASE_URL}/api/planning/getusersheduledList`,
  }
    return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
  }


export async function getHistoryPlanningOverview(
  salesOrg: string,
  deliveryPlant: string,
  startDate: Date,
  planMode:string
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      deliveryPlant,
      startDate,
      planMode
    },
    url: `${BASE_URL}/api/planning/historyOverview`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function releaseValidation(
  salesOrg: string,
  visit_dt_plan:Date,
  deliveringplant:string,
  releaseData:[]
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
     
    },
    data: {
      "visit_dt_plan":visit_dt_plan,
      "deliveringplant":deliveringplant,
      "releaseData":releaseData
    },
    url: `${BASE_URL}/api/planning/release_validation`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function getHistoryFordatePicker(
  salesOrg: string,
  deliveringplant:string,
  route:string
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      plant:deliveringplant,
      route:route
    },
    url: `${BASE_URL}/api/planning/getHistoryFordatePicker`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetRouteReset( salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
       clientId: "100",
       salesOrg: salesOrg
    },
    url: `${BASE_URL}/api/planning/getRouteResetSetting`,
  };
  return await AXIOS_INSTANCE(config)
  .then((v) => v.data)
  .catch((err) => console.error(err));
}

export async function saveReviewData(
  salesOrg: string,
  reviewData: any,
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg
    },
    data: reviewData,
    url: `${BASE_URL}/api/planning/review/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function deleteReviewData(
  salesOrg: string,
  reviewData: any,
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg
    },
    data: reviewData,
    url: `${BASE_URL}/api/planning/review/delete`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function updateReadyToReviewStatus(
  salesOrg: string,
  reviewData: any,
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg
    },
    data: reviewData,
    url: `${BASE_URL}/api/planning/review/status`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getReadyToReviewStatus(
  salesOrg: string,
  reviewData: any,
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      ...reviewData
    },
    url: `${BASE_URL}/api/planning/review/status`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

